import { useState } from 'react'

import { PlaneTakeoffIcon, CodeXmlIcon, MousePointerClickIcon } from 'lucide-react'

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'

import { MotionPreset } from '@/components/ui/motion-preset'

const featureData = [
  {
    id: 'unified-platform',
    icon: PlaneTakeoffIcon,
    title: 'One unified platform',
    description:
      'Database, signals, sequences, pipeline tracking, call recording, and more.',
    image: 'https://cdn.shadcnstudio.com/ss-assets/blocks/marketing/features/image-1.png',
    imageAlt: 'Dashboard Preview'
  },
  {
    id: 'interactions-catalogued',
    icon: CodeXmlIcon,
    title: 'Every interaction catalogued',
    description: 'Emails, calls, meeting recordings, and messages are automatically captured, summarized, and turned into structured records.',
    image: 'https://cdn.shadcnstudio.com/ss-assets/blocks/marketing/features/image-11.png',
    imageAlt: 'Interactions Preview'
  },
  {
    id: 'demand-to-pipeline',
    icon: MousePointerClickIcon,
    title: 'From demand generation to pipeline conversion',
    description: 'ProspectHunter agents are constantly taking action to generate new opportunities and close more revenue.',
    image: 'https://cdn.shadcnstudio.com/ss-assets/blocks/marketing/features/image-12.png',
    imageAlt: 'Pipeline Preview'
  }
]

const AccordionWithImage = () => {
  const [activeAccordion, setActiveAccordion] = useState('unified-platform')

  const handleAccordionChange = (value: string) => {
    setActiveAccordion(value)
  }

  const activeFeature = featureData.find(feature => feature.id === activeAccordion) || featureData[0]

  return (
    <MotionPreset fade blur slide={{ direction: 'down', offset: 50 }} delay={0.6} transition={{ duration: 0.5 }}>
      <div className='grid gap-12 lg:grid-cols-[2fr_3fr]'>
        <div className='flex items-center'>
          <Accordion
            type='single'
            collapsible
            className='w-full space-y-2'
            value={activeAccordion}
            onValueChange={handleAccordionChange}
          >
            {featureData.map((item, index) => (
              <AccordionItem key={index} value={item.id} className='rounded-md border!'>
                <AccordionTrigger className='px-5'>
                  <span className='flex items-center gap-4'>
                    <item.icon className='size-4 shrink-0' />
                    <span className='text-base'>{item.title}</span>
                  </span>
                </AccordionTrigger>

                <AccordionContent className='text-muted-foreground px-5 text-base'>{item.description}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* Image */}
        <div className='bg-primary/10 relative mt-auto max-h-80 overflow-hidden rounded-lg px-6 pt-14 max-lg:shrink-0'>
          <MotionPreset key={activeFeature.id} fade slide={{ direction: 'down' }} transition={{ duration: 0.35 }}>
            <img
              src={activeFeature.image}
              alt={activeFeature.imageAlt}
              className='w-full rounded-t-xl object-cover dark:hidden'
            />
            <img
              src={`${activeFeature.image.replace('.png', '-dark.png')}`}
              alt={activeFeature.imageAlt}
              className='hidden w-full rounded-t-xl object-cover dark:inline-block'
            />
          </MotionPreset>
        </div>
      </div>
    </MotionPreset>
  )
}

export default AccordionWithImage
